const prefix = 'game';

export const addTrending = `${prefix}/trending`;

export const toggleTrending = (gameId) => `${prefix}/${gameId}/trending`;
